
window._ = {};

window._.debounce   = require('lodash/debounce');
window._.map        = require('lodash/map');
window._.delay      = require('lodash/delay');
